// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfYear as fn } from "../startOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfYear;
